<template>
  <SolutionPageLayout title="Sponsorship" section="Outcomes">
    <p>
      Sponsors expect measurable exposure, qualified leads, and a professional experience that reflects their brand alongside yours.
    </p>
    <p>
      Entegy connects the dots between digital touchpoints and on-site activations—helping you package, deliver, and report on sponsorship value with less manual effort.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
